import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';

const SECTION_ID = 'home-page-section-e';

const IMAGE_CONTAINER_CLASS = 'image-container';
const TEXT_CLASS = 'text';
const BUTTON_CLASS = 'button';

class AnimationsHomeSectionE {
    constructor() {
        this._section = document.getElementById(SECTION_ID);

        this._section && this._run();
    }
    _run = () => {
        this._media = gsap.matchMedia();

        this._imageContainer = this._section.querySelector(`.${IMAGE_CONTAINER_CLASS}`);
        this._image = this._section.querySelector(`.${IMAGE_CONTAINER_CLASS}>*`);
        this._text = this._section.querySelector(`.${TEXT_CLASS}`);
        this._button = this._section.querySelector(`.${BUTTON_CLASS}`);

        this._media.add(
            {
                isDesktop: `(min-width: ${screenSm}px)`,
                isMobile: `(max-width: ${screenSm - 1}px)`,
                reduceMotion: '(prefers-reduced-motion: reduce)',
            },
            this._createAnimationTimeline,
        );
    };

    _createAnimationTimeline = (context) => {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;
        //ScrollTrigger.refresh();
        gsap.to(this._image, {
            scale: 1.2,
            scrollTrigger: {
                trigger: this._imageContainer,
                start: 'top bottom',
                end: 'bottom top',
                markers: false,
                scrub: 1,
            },
            onStart: () => {
                //ScrollTrigger.refresh();
            },
        });
    };
}
const animationsHomeSectionE = new AnimationsHomeSectionE();
